/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Images_HintInputs */

const vi_shop_group_images_hint = /** @type {(inputs: Shop_Group_Images_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm không có ảnh riêng: web và Mini App hiện ảnh sản phẩm của loại khách đang chọn (ảnh bìa danh sách = ảnh loại mặc định). Sửa ảnh ở trang sản phẩm › Thiết kế ảnh.`)
};

/**

* @param {Shop_Group_Images_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_images_hint = /** @type {((inputs?: Shop_Group_Images_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Images_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_images_hint(inputs)
});